<script>
import { Card } from "vant";
import { Col, Row } from "vant";
import { formatDateToYYYYMMDD, formatDateTime } from "@/ultis/dateFormat";
import syncIconActive from "@/static/icon-sync1.png";
import syncIcon from "@/static/icon-sync2.png";

export default {
  name: "HistoryItem",
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  components: {
    [Card.name]: Card,
    [Col.name]: Col,
    [Row.name]: Row,
  },
  data() {
    return { syncIcon, syncIconActive };
  },
  computed: {
    statusKey() {

      //TODO: Hoai dev here
      let isDev = false;
      if (isDev) {
       return "pending"
      }


      const s = Number(
        this.data && (this.data.status ?? this.data.paymentStatus),
      );

      if (s === null || s === undefined) return "";
      // numeric codes
      if (s === 1 || s === "1") return "success";
      if (s === 2 || s === "2") return "failed";
      if (s === 3 || s === "3") return "pending";
      return String(s).toLowerCase();
    },

    statusType() {
      const key = this.statusKey;
      if (key === "success") return "success";
      if (key === "failed") return "danger";
      if (key === "pending") return "warning";

      return "default";
    },

    statusLabel() {
      const key = this.statusKey;
      if (!key) return "";
      const tvKey = `tv360.status_${key}`;
      if (this.$t && this.$t(tvKey)) return this.$t(tvKey);
      if (this.$t && this.$t(key)) return this.$t(key);
      return String(key);
    },

    statusClass() {
      const key = (this.statusKey || "").toString().trim().toLowerCase();
      if (!key) return "";
      return "van-tag--" + key.replace(/\s+/g, "-");
    },
    hasUpdateDate() {
      return (
        this.data.updateDate != null &&
        this.data.updateDate !== undefined &&
        this.data.updateDate !== ""
      );
    },
    syncActive() {
      //TODO: Hoai dev here
      let isDev = false;
      if (isDev) {
        return true;
      }

      if (!this.hasUpdateDate) return false;
      const key = this.statusKey;
      if (key === "pending") {
        const ud = new Date(this.data.updateDate);
        if (isNaN(ud.getTime())) return false;
        const diff = Date.now() - ud.getTime();
        return diff >= 5 * 60 * 1000; // >= 5 minutes
      }
      return false;
    },
    showSyncButton() {
      //TODO: Hoai dev here
      let isDev = false;
      if (isDev) {
        return true;
      }

      const key = this.statusKey;
      return key === "pending";
    },
  },
  methods: {
    formatDateToYYMMDD(input, type) {
      if (type == "date") {
        return formatDateToYYYYMMDD(input);
      }
      if (type == "time") {
        return formatDateTime(input);
      }
      return "";
    },
    fixedPrice(price) {
      if (price) {
        price = Number(price);
        return price.toFixed(2);
      }
      return price;
    },
    onSync() {
      if (!this.syncActive) {
        return;
      }
      const payload =
        this.data && typeof this.data === "object"
          ? JSON.parse(JSON.stringify(this.data))
          : this.data;
      this.$emit("sync", payload);
    },
    displayPrice(price) {
      if (price == null) return "";
      const n = Number(price);
      if (Number.isInteger(n)) return n.toString();
      return n.toFixed(2);
    },
  },
};
</script>

<template>
  <div>
    <van-card :thumb="data.iconUrl" class="van-card-post tv360-history-item">
      <div class="price-badge">
        {{ data.unit || "$" }}{{ displayPrice(data.price) }}
      </div>
      <template #tags>
        <van-row>
          <van-col span="24">
            <div
              class="d-flex van-row--justify-space-between van-row--align-center"
            >
              <h3 class="van-card__title">
                {{ data.name || data.serviceName }}
              </h3>
              <div class="status-badge">
                <van-tag
                  :type="statusType"
                  plain
                  :class="['status-tag', statusClass]"
                >
                  {{ statusLabel }}
                </van-tag>
                <button
                  v-if="showSyncButton"
                  class="history-sync-btn"
                  @click.stop="onSync"
                  :aria-label="sync"
                >
                  <img
                    class="history-sync-icon"
                    :src="syncActive ? syncIconActive : syncIcon"
                    alt="sync"
                  />
                </button>
              </div>
            </div>

            <!-- Price row -->
            <div class="d-flex align-items-center cs-van-tag">
              <van-tag plain type="danger" class="van-tag-icon">
                <div class="currency-unit-box">
                  <p class="currency-unit">{{ data.unit }}</p>
                </div>
              </van-tag>

              <van-tag plain type="danger" class="van-tag-price">
                {{ fixedPrice(data.price) }}
              </van-tag>

              <van-tag plain type="danger" class="van-tag-day"
                >/ {{ data.validity }}</van-tag
              >
            </div>

            <!-- Register date -->
            <div class="d-flex align-items-center cs-van-tag">
              <div class="register-line">
                {{ $t("tv360.txt_register") }}:
                {{ formatDateToYYMMDD(data.registerDate, "time") }}
              </div>
            </div>
          </van-col>
        </van-row>
      </template>
    </van-card>
  </div>
</template>

<style>
.tv360-history-item .cs-van-tag {
  margin-bottom: 0px;
}

.tv360-history-item .van-card__thumb {
  margin-top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 60px;
  width: 60px;
  height: 60px;
  box-sizing: border-box;
  overflow: hidden;
}

.tv360-history-item {
  position: relative;
}

/* Make the card a horizontal flex to vertically center thumb + content */
.van-card-post.tv360-history-item,
.tv360-history-item.van-card-post {
  display: block !important;
  /* align-items: stretch !important;*/
  gap: 12px;
  padding: 8px 12px !important;
  /*min-height: 80px;*/
}

.van-card-post.tv360-history-item .van-card__thumb,
.tv360-history-item.van-card-post .van-card__thumb {
  /*align-self: center;*/
}

.van-card-post.tv360-history-item .van-card__content,
.tv360-history-item.van-card-post .van-card__content {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 !important;
}

.tv360-history-item .price-badge {
  position: absolute;
  left: 12px;
  top: 12px;
  background: #ff2d2d;
  color: #fff;
  padding: 6px 10px;
  border-radius: 8px;
  font-weight: 700;
  z-index: 5;
}

.tv360-history-item .status-badge {
  margin-left: auto;
  display: flex;
  align-items: center;
}

.tv360-history-item .register-line {
  color: #f0a500;
  font-size: 13px;
  margin-top: 2px;
}

.tv360-history-item .van-tag--plain {
  border: 1px solid transparent !important;
  padding: 4px 12px !important;
  border-radius: 999px !important;
  font-size: 14px !important;
  text-align: center;
  min-width: 0 !important;
  line-height: 1 !important;
}
.tv360-history-item .van-tag--plain.van-tag--success {
  background: #eafaf0 !important;
  color: #1f7a4a !important;
  border-color: rgba(31, 122, 74, 0.12) !important;
}
.tv360-history-item .van-tag--plain.van-tag--danger {
  background: #fff5f5 !important;
  color: #c0392b !important;
  border-color: rgba(192, 57, 43, 0.08) !important;
}
.tv360-history-item .van-tag--plain.van-tag--warning {
  background: #fff9ec !important;
  color: #b86b00 !important;
  border-color: rgba(184, 107, 0, 0.08) !important;
}

.tv360-history-item .status-badge {
  margin-left: auto;
  display: flex;
  align-items: center;
}

/* Explicit class for status tag so we can target it directly */

.tv360-history-item .status-tag {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 8px 12px !important;
  border-radius: 14px !important;
  font-size: 13px !important;
  line-height: 1 !important;
  min-width: 56px !important;
  text-align: center;
  box-shadow: none !important;
  border: none !important;
}

/* Specific color variants for the visible pill in the design */
.tv360-history-item .status-tag.van-tag--success {
  background: #eafaf0 !important;
  color: #027a48 !important;
  border: none !important;
}
.tv360-history-item .status-tag.van-tag--failed {
  background: #fff5f5 !important;
  color: #e81707 !important;
  border: none !important;
}
.tv360-history-item .status-tag.van-tag--pending {
  background: #fff8e6 !important;
  color: #fdb913 !important;
  border: none !important;
}

.tv360-history-item .history-sync-btn {
  position: absolute;
  right: 20px;
  top: 48px;
  transform: translateY(-50%);
  width: 35px;
  height: 35px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: none;
  background: transparent;
}

.tv360-history-item .history-sync-btn:active {
  opacity: 0.8;
}

.tv360-history-item .status-badge {
  position: relative; /* allow absolute positioning of sync button */
}

.tv360-history-item .history-sync-symbol {
  color: #fff;
  font-size: 14px;
  line-height: 1;
}

.tv360-history-item .history-sync-icon {
  display: block;
  object-fit: contain;
}
</style>
